var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',_vm._b({ref:"img",staticClass:"lazy-img",class:[
    {
      'lazy-img--loaded': _vm.isLoaded,
      'lazy-img--visibility': _vm.useVisibility,
    },
    _vm.$attrs.class,
  ],attrs:{"src":_vm.loadedSrc,"data-src":_vm.src,"alt":_vm.alt,"loading":"lazy"},on:{"load":_vm.onImageLoaded,"error":_vm.onImageError}},'img',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }